import * as React from 'react';
import classNames from 'classnames';
import convertToIContextualMenuItem from '../utils/convertToIContextualMenuItem';
import strings from 'owa-strings/owa-extensibility-strings';
import { Addin } from 'owa-addins-store';
import { ControlIcons } from 'owa-addins-icons';
import { createAddinCommandSurfaceActions } from '../utils/contextMenuDataUtils';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { IconType } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';

const styles = require('./OverflowMenuView.scss');

export interface OverflowMenuViewProps {
    hostItemIndex: string;
    addins: Addin[];
}

@observer
export default class OverflowMenuView extends React.Component<OverflowMenuViewProps, {}> {
    handleChevronLeftClick = (e: any) => {
        e.stopPropagation();
    };

    render() {
        const iconProps = {
            iconType: IconType.Default,
            iconName: ControlIcons.ChevronDownMed,
            className: classNames([styles.overflowChevron]),
        };

        const props = {
            className: classNames([styles.overflowChevronContainer]),
            iconProps: iconProps,
            title: strings.overflowMenuTooltip,
            ariaLabel: strings.overflowMenuAccessibilityLabel,
        };

        const menuData = createAddinCommandSurfaceActions(this.props.addins);
        convertToIContextualMenuItem(this.props.hostItemIndex, menuData);

        return (
            <div className={classNames([styles.overflowContainer])}>
                <div className={classNames([styles.overflowDivider])} />
                <IconButton
                    onMenuClick={this.handleChevronLeftClick}
                    menuProps={{ items: [menuData] }}
                    menuIconProps={null}
                    {...props}
                />
            </div>
        );
    }
}
